import { columns } from '@ipc/ipc-components';
import column from '../../../../common/list-table/helpers/columns';

export default (data, userRole, onRowDelete) => {
  const {
    FilteredTextColumn,
    ActionColumn,
  } = column(data);

  const {
    NumberColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new NumberColumn('ID', 'id').withShow(false),
        new FilteredTextColumn('Target group', 'targetGroupCode').withShow(false),
        new FilteredTextColumn('Element', 'name'),
        new NumberColumn('Threshold (hours)', 'value'),
        new FilteredTextColumn('Notification ContactGroup', 'contactGroup'),
        new ActionColumn([['DELETE', 'id', onRowDelete, true]]).withShow(userRole === 'IPC_ADMIN'),
      ],
    },
  ];
};
export const editColumns = (data, setData) => {
  const {
    NotFilteredTextColumn,
    EditableSelectColumn,
    EditableInputColumn,
  } = column(data);

  const {
    NumberColumn,
  } = columns(data);
  const targetGroupCodeOptions = {
    MRD: ['IPC', 'MRD'],
    DATA_SHARING_OUTBOUND: ['IPC', 'DATA_SHARING'],
    DATA_SHARING_INBOUND: ['IPC', 'DATA_SHARING'],
  };
  const elementsRestrictions = {
    FLIGHT_SCHEDULE_THRESHOLD: ['MRD'],
    ACTUAL_FLIGHT_TIME_THRESHOLD: ['MRD'],
    HANDOVER_DATA_DROP_THRESHOLD: ['DATA_SHARING'],
  };
  const populateOptions = (cellInfo) => (elementsRestrictions[cellInfo.original.name] !== undefined
    ? targetGroupCodeOptions[cellInfo.original.targetGroupCode].filter((item) => !elementsRestrictions[cellInfo.original.name].includes(item))
    : targetGroupCodeOptions[cellInfo.original.targetGroupCode]);
  const validateInput = (input) => {
    const result = input.replace(/\D/g, '');
    return result.slice(0, 3);
  };

  return [
    {
      Header: '',
      columns: [
        new NumberColumn('ID', 'id').withShow(false),
        new NotFilteredTextColumn('Target group', 'targetGroupCode').withShow(false),
        new NotFilteredTextColumn('Element', 'name'),
        new EditableInputColumn('Threshold (hours)', 'value', true, data, setData, validateInput),
        new EditableSelectColumn('Notification ContactGroup', 'contactGroup', true, data, setData, populateOptions),
      ],
    },
  ];
};
